import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { get } from "../../../helpers/api_helper";
import { CardInfoGetScanInventory } from "../../ScanInventory/card-info-get-scan-inventory";
export const ModalShowScanInvetory = ({
  toggle,
  isOpen,
  billId,
}) => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    getHistory();
  }, [billId]);

  const getHistory = () => {
    get(`/bills/get-scan-inventory/${billId}`, {}, {})
      .then((result) => {
        setHistory(result);
      });
  }
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader>{'Quét đơn hàng'}</ModalHeader>
      <ModalBody>
        <div className="get-scan-inventory_history">
          <Row>
            {history.map((e, i) =>
              <Col key={i} md={12}>
                <CardInfoGetScanInventory data={e} />
              </Col>
            )}
          </Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>{'Đóng'}</Button>
      </ModalFooter>
    </Modal >
  )
}